const lineChartTag = 'line chart';
const multiLineTag = 'multi-line';
const stackedAreaTag = 'stacked area';
const areaChartTag = 'area chart';
const pieChartTag = 'pie chart';
const barChartTag = 'bar chart';
const columnChartTag = 'column chart';
const doubleColumnChartTag = 'double column';
const stackedBarTag = 'stacked bar';
const donutChartTag = 'donut chart';
const bubbleChartTag = 'bubble chart';
const scatterChartTag = 'scatter chart';
const gaugeChartTag = 'gauge chart';
const radarChartTag = 'radar chart';
export const templateTagQueries = {
  StackedBar: '',
  //stackedBarTag,
  Bar: '',
  //columnChartTag,
  HorizontalBar: '',
  //barChartTag,
  DoubleBar: '',
  //doubleColumnChartTag,
  Line: lineChartTag,
  Area: '',
  //areaChartTag,
  // StackedArea: stackedAreaTag,
  Pie: pieChartTag,
  Donut: '',
  //donutChartTag,
  Bubble: '',
  //bubbleChartTag,
  Scatter: '',
  //scatterChartTag,
  Gauge: '',
  //gaugeChartTag,
  Radar: '' //radarChartTag,

};
export const nonUserFacingTags = ['chart', 'light', 'dark', lineChartTag, multiLineTag, barChartTag, stackedAreaTag, areaChartTag, pieChartTag, doubleColumnChartTag, stackedBarTag, bubbleChartTag, donutChartTag, columnChartTag, scatterChartTag, gaugeChartTag, radarChartTag];
export const previewStorageUrl = 'https://graphitup.b-cdn.net/templates';